<template>
  <div class="cpt-member-manage-scroll-item-wrapper scroll-item-wrapper">
    <div class="title">成员管理</div>
    <div class="module">
      <div class="top-block">
        <Input
          class="setting-input"
          icon="icon-search-bold"
          size="big"
          :disabled="showMenuName !== ''"
          v-model="filter_params.type_str"
          clearable
          placeholder="搜索房间成员"
        />
        <div
          class="inactive-filter-btn pointer flex-items-center h-[42px] min-w-[142px] px-[16px] gap-[3px] rounded-[5px] bg-op-1 text-op-5 text-[14px] whitespace-nowrap"
          :class="{'active': showMenuName == 'inactive-filter' || isValidInactiveCondition}"
          @click.stop="handleShowMenu('inactive-filter')"
        >
          筛选不活跃成员
          <i class="iconfont icon-arrow-down"></i>
        </div>
        <div class="heybox-context-menu inactive-member-filter" ref="filter-enter-time-menu" v-show="showMenuName == 'inactive-filter'">
          <InactiveMemberFilter 
            :inactiveConditions="inactiveConditions" 
            @addCondition="handleAddCondition"
            @changeCondition="handleChangeCondition"
            @removeCondition="handleRemoveCondition"
          />
        </div>
      </div>
      <div class="member-table min-h-[450px]">
        <div class="member-table-head">
          <div class="select" @click.stop="handleChangeAll">
            <i class="iconfont icon-toast-success-square" v-if="selectMemberList.length == showMemberList.length"></i>
            <i class="iconfont icon-toast-stop-square" v-else-if="selectMemberList.length"></i>
            <i class="none-select" v-else></i>
          </div>
          <div class="member-info filter-head-item">
            成员/加入时间
            <div class="filter-wrapper">
              <i class="iconfont icon-filter" @click.stop="handleShowMenu('enter-time')" :class="{'active': isShowEnterTimeMenu || isUsingJoinTimeFilter || isUsingJoinTimeCustomFilter}" />
            </div>
            <div class="heybox-context-menu enter-time-menu" ref="filter-enter-time-menu" v-show="isShowEnterTimeMenu">
              <MemberManageFilter 
                type='enter-time' 
                v-model="rangeParams.join_times" 
                :ranges="enterTimeCustomRange"
                :customFormatter="dateFormatter"
                @switchPanel="(v)=> customRangeName = v ? 'enter-time' : ''"
                @clearCustomRange="enterTimeCustomRange = ['0', '0']"
              />
            </div>
            <div class="heybox-context-menu heybox-context-menu-range time-panel" v-if="customRangeName === 'enter-time' && isShowEnterTimeMenu">
              <MemberManageCustomRange
                title="自定义加入时间范围"
              >
                <TimeSelector
                 :range="enterTimeCustomRange"
                 dateFormat="yyyy.MM.dd"
                 @updateValue="handleUpdateEnterTimeCustomRange"
                />
              </MemberManageCustomRange>
            </div>
          </div>
          <div class="member-hb-level filter-head-item" @click.stop="">
            等级
            <div class="filter-wrapper">
              <i class="iconfont icon-filter" :class="{'active': isShowLevelMenu || isUsingLevelFilter || isUsingLevelCustomFilter}" @click.stop="handleShowMenu('level')"/>
            </div>
            <div class="heybox-context-menu level-menu" :class="{'has-custom': customRangeName === 'level' && isShowLevelMenu}" ref="filter-level-menu" v-show="isShowLevelMenu">
              <MemberManageFilter 
                v-model="rangeParams.level" 
                :ranges="levelCustomRange"
                :customFormatter="(value1, value2) => `Lv.${value1} - Lv.${value2}`"
                type="level" 
                @switchPanel="(v)=> customRangeName = v ? 'level' : ''"
                @clearCustomRange="levelCustomRange = [0, 0]"
              />
            </div>
            <div class="heybox-context-menu heybox-context-menu-range level-panel" v-if="customRangeName === 'level' && isShowLevelMenu">
              <MemberManageCustomRange
                title="自定义小黑盒等级范围"
              >
                <HeyboxLevelRange
                  :range="levelCustomRange"
                  @updateValue="handleUpdateLevelCustomRange"
                ></HeyboxLevelRange>
              </MemberManageCustomRange>
            </div>
          </div>
          <div class="member-invite-info" @click.stop="handleClickInviteUser">邀请人</div>
          <div class="member-role filter-head-item">
            <div class="flex" @click.stop="handleShowMenu('role')">
              <span>权限组</span>
              <div class="filter-wrapper" :class="{'active': isShowRoleMenu || filter_params.role_ids.length}">
                <i class="iconfont icon-filter" :class="{'active': isShowRoleMenu}"></i>
              </div>
              <div class="heybox-context-menu" ref="filter-role-menu" v-show="isShowRoleMenu" :style="MenuPosition">
                <RoleItem 
                  class="menu-item"
                  :class="{'gradient': item.gradient}"
                  v-for="item, index in allRoleList"
                  :key="item.label + '' + index"
                  :role="item.role"
                  @click.stop.native="handleFilterRoleChange(item)"
                >
                  <!-- <div class="radio" :class="{active: filter_params.role_ids.indexOf(item.role.id) > -1}"></div> -->
                  <div class="select-icon">
                    <div class="unselected" v-if="filter_params.role_ids.indexOf(item.role.id) === -1"></div>
                    <i class="selected iconfont icon-toast-success" v-else></i>
                  </div>
                </RoleItem>
              </div>
            </div>
            
          </div>
          <div class="member-status filter-head-item">
            <div class="flex" @click.stop="handleShowMenu('status')">
              <span>状态</span>
              <div class="filter-wrapper" :class="{'active': isShowStatusMenu || filter_params.is_ban}">
                <i class="iconfont icon-filter" :class="{'active': isShowStatusMenu}"></i>
              </div>
              <div class="heybox-context-menu status-menu" v-show="isShowStatusMenu">
                <div 
                  class="menu-item"
                  @click.stop="handleFilterStatusChange"
                >
                  <i class="iconfont icon-history"></i>
                  <span>已被禁言</span>
                  <div class="radio" :class="{active: filter_params.is_ban}"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="member-table-body" v-if="showMemberList.length">
          <div 
            class="member-list"
            v-delegate="{
              mouseover: {
                'member-item': {
                  handler: handleHoverMember
                }
              },
              mouseout: {
                'member-item': {
                  handler: handleMouseLeave
                }
              }
            }"
          >
            <div 
              class="member-item"
              v-for="(member, index) in showMemberList"
              :key="member.user_id + '-' + index"
              @click="handleSelectMember(member)"
              :data-delegate-member-item="member.user_id"
            >
              <div class="select">
                <i class="iconfont icon-toast-success-square" v-if="selectMemberList.findIndex(user => user.user_id == member.user_id) > -1"></i>
                <i class="none-select" v-else></i>
              </div>
              <div class="member-info">
                <div class="member-info-left">
                  <Avatar
                    :img="member.avatar"
                    :hideOnline="true"
                    :avatar_decoration="member.avatar_decoration || {}"
                    @click.native.stop="showUserInviteCode"
                  />
                </div>
                <div class="member-info-right">
                  <div class="member-name"><span class="show-name">{{ member.show_name }}</span> <span v-if="member.user_id == cur_room_data.create_by" class="master-tag">房主</span> </div>
                  <div class="member-inactive-time" v-if="isValidInactiveCondition && hoverMemberId != member.user_id"> {{ getInactiveText(member) }} </div>
                  <div class="member-enter-time" v-else>{{ getEnterTimeFormat(member.join_time) }}</div>
                </div>
              </div>
              <div class="member-hb-level">
                <div class="heybox-level" v-tooltip="{'text': `小黑盒等级 Lv.${member.level}`,'placement': 'top'}" v-if="member.hasOwnProperty('level')">
                  <HbLevel :level="member.level"/>
                  <div class="num">{{ member.level }}</div>
                </div>  
              </div>
              <div class="member-invite-info">
                <Avatar 
                  v-if="member.invitor?.user" 
                  :img="member.invitor.user.avatar" 
                  class="member-invitor-avatar"
                  :hideOnline="true"
                  v-tooltip="{text: getInviteTooltip(member)}"
                  @click.native.stop="showUserInviteCode(member)"
                />
                <div class="invite-way" v-else>
                  {{ INVITE_TYPE_STRING[member.invitor?.invite_type] || member.invitor?.invite_desc }}
                </div>
              </div>
              <div class="member-role role-list-wrapper">
                <RoleItem 
                  class="role-item" 
                  :role="member.user_roles[0]" 
                  v-if="member.user_roles && member.user_roles.length > 0" 
                />
                <Tooltip v-if="member.user_roles && member.user_roles.length > 1">
                  <div slot="content">
                    <div class="role-tip-content role-list-wrapper">
                      <RoleItem
                        class="role-item"
                        v-for="role in member.user_roles.slice(1)"
                        :key="member.user_id + '-' +role.id"
                        :role="role"
                      />
                    </div>
                  </div>
                  <div class="more-role">
                    +{{ member.user_roles.length - 1 }}
                  </div>
                </Tooltip>
              </div>
              <div class="member-status">
                <i
                  v-if="member.is_banned"
                  v-tooltip="{ text: hoverBanDesc }"
                  class="iconfont icon-history"
                  @mouseenter="handleMouseOverBan(member)"
                  @mouseleave="handleMouseLeaveBan(member)"
                ></i>
              </div>
              <div
                class="action-btn"
                v-if="is_master || member.show_manage_role || member.show_ban || member.show_kick_out || member.show_black"
                @click.stop="showMemberActionMenu(member, $event)"
              >
                <i class="iconfont icon-more"></i>
              </div>
            </div>
            <ChatMoreLoading v-if="is_loading"/>
          </div>
          <div 
            v-if="hoverMember?.show_manage_role"
            class="add-role-btn absolute w-[30px] h-[30px] flex items-center justify-center cursor-pointer rounded-[4px] bg-op-1 hover:bg-op-2"
            v-tooltip="{ text: '添加权限组' }"
            @click.prevent.stop="showManageRoleMenu($event, hoverMember)"
            @mouseleave="handleAddRoleBtnLeave"
            :style="addRoleBtnStyle"
          >
            <i class="iconfont icon-add-bold !text-[12px] text-op-4"></i>
          </div>
        </div>
      </div>
      <transition name="slide">
        <div class="action-panel" v-show="showActionPanel">
          <div class="select-desc">已选中 {{ selectMemberList.length }} 位:</div>
          <div
            v-for="action in action_list"
            :key="action.type"
            v-tooltip="{ text: action.disabled_desc, disable: !action.disabled }"
            class="action-item"
            :class="{'disabled': action.disabled || (action.type === 'revoke_role' && !is_select_has_role), 'red': action.red}"
            @click.stop="handleActionPanel(action, $event)"
          >
            {{ action.label }}
            <i
              v-if="action.icon"
              class="iconfont"
              :class="[action.icon, {'rotate': showBatchRoleMenu ? action.type === 'revoke_role' ? isRevokeMenu : !isRevokeMenu : false}]"
            ></i>
          </div>
          <div class="close-btn" @click="closeActionPanel">
            <i class="iconfont icon-close-bold"></i>
          </div>
          <div class="heybox-context-menu role-menu" :class="{'revoke-menu': isRevokeMenu}" v-show="showBatchRoleMenu">
            <MenuButton
              @click.native="handleRoleUsers(selectMemberList, item.data.role)"
              v-for="item, index in showBatchRoleList"
              :key="index"
              :data="item.data"
            />
          </div>
        </div>
      </transition>
    </div>  
  </div>
</template>

<script>
import Avatar from '_com/func/Avatar'
import MenuButton from '_lib/ContextMenu/components/MenuButton.vue';

import { debounce, formatLeftTime, timeFormat } from "_lib/utils/utils";
import { calcUserName } from '_lib/CalcUserInfo';
import EventBus from '@/common/EventBus';
import { mapGetters } from "vuex";

import { kickOutFromRoom, batchKickOutFromRoom } from "_api/channel";
import { getManageMember } from "_api/room/index";
import { addRoleUsers, revokeRoleFromUsers, batchAddRoleUsers, batchRevokeRoleFromUsers } from "_api/role";
import {
  INACTIVE_TYPE_OPTIONS,
} from '_lib/constants/member-manage';
import MemberManageFilter from '../components/MemberManageFilter.vue';
import { ROLE_TYPES } from '@/common/constants/role';
import { decimalToHexColor } from '_lib/utils/utilsColor';
import RoleItem from '_com/func/RoleItem.vue';
import HbLevel from '_com/func/HbLevel.vue';
import TimeSelector from '_com/func/TimeSelector.vue';
import HeyboxLevelRange from '_com/func/HeyboxLevelRange.vue';
import MemberManageCustomRange from '../components/MemberManageCustomRange.vue';
import { INVITE_TYPE_STRING } from '_lib/constants/room'
import InactiveMemberFilter from '../components/InactiveMemberFilter.vue';
function getFormatTitle (users) {
  let title = '确定将 '
  const list = users.slice(0, 2)
  title += list.map(user => user.show_name).join('、')
  if (users.length > 2) {
    title += `等 ${users.length} 位成员`
  } else {
    title += ' '
  }
  return title
}
export default {
  components: {
    Avatar,
    MenuButton,
    RoleItem,
    HbLevel,
    MemberManageFilter,
    HeyboxLevelRange, 
    TimeSelector,
    MemberManageCustomRange,
    InactiveMemberFilter,
  },
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      offset: 0,
      limit: 30,
      searchKeyword: '',
      memberList: [],
      memberSearchList: [],
      selectMemberList: [],
      isSelectAll: false,
      filter_params: {
        type_str: '',
        role_ids: [],
        is_ban: false,
      },
      rangeParams: {
        level: ['0', '0'],
        join_times: ['0', '0'],
      },
      hoverBanDesc: '',
      is_loading: false,
      MenuPosition: {},
      showActionPanel: false,
      action_list: [{
        label: '授予权限组',
        type: 'add_role',
        icon: 'icon-arrow-down',
        disabled: false,
        disabled_desc: '',
      }, {
        label: '剥夺权限组',
        type: 'revoke_role',
        icon: 'icon-arrow-down',
        disabled: false,
        disabled_desc: '',
      }, {
        label: '禁言',
        type: 'ban_user',
        red: true,
        icon: '',
        disabled: true,
        disabled_desc: '',
      }, {
        label: '移出房间',
        type: 'kick_out_room',
        red: true,
        icon: '',
        disabled: false,
        disabled_desc: '',
      }, {
        label: '移出并拉黑',
        type: 'kick_out_and_black',
        red: true,
        icon: '',
        disabled: false,
        disabled_desc: '',
      }],
      banInterval: null,

      showBatchRoleMenu: false,
      isRevokeMenu: false,
      showBatchRoleList: [],
      showEnterTimeMenu: false,
      showLevelMenu: false,
      levelMenuPosition: {},
      enterTimeMenuPosition: {},


      showMenuName: '',
      customRangeName: '',
      levelCustomRange: [0, 0],
      enterTimeCustomRange: ['0', '0'],
      INVITE_TYPE_STRING,
      hoverMemberId: '',
      inactiveConditions: [{time: undefined, type: undefined, id: this.randomToken()}],
      hoverMember: null,
      addRoleBtnStyle: {
        top: '0px',
        left: '0px'
      }
    }
  },
  beforeDestroy () {
    clearTimeout(this.scrollTimer)
    clearTimeout(this.filterRequestTimer)
    clearInterval(this.banInterval)
    this.removeListener()
    EventBus.$off('Refresh_Batch_Manage_List', this.refreshMemberList)
  },
  computed: {
    isShowEnterTimeMenu () {
      return this.showMenuName === 'enter-time'
    },
    isShowLevelMenu () {
      return this.showMenuName === 'level'
    },
    isShowRoleMenu () {
      return this.showMenuName === 'role'
    },
    isShowStatusMenu () {
      return this.showMenuName === 'status'
    },
    isUsingLevelFilter(){
      return this.rangeParams.level.some(item => item !== '0')
    },
    isUsingJoinTimeFilter(){
      return this.rangeParams.join_times.some(item => item !== '0')
    },
    isUsingJoinTimeCustomFilter(){
      return this.enterTimeCustomRange.some(item => item !== '0')
    },
    isUsingLevelCustomFilter(){
      return this.levelCustomRange.some(item => item !== 0)
    },
    showMemberList() {
      if (this.isSearching) {
        return this.memberSearchList
      } else {
        return this.memberList
      }
    },
    source_position() {
      return this.$permission.calcUserPosition(this.cur_my_roles, this.user_info.user_id)
    },
    isSearching() {
      return !!this.filter_params.type_str.trim()
    },
    // 全部权限组列表
    allRoleList () {
      const allRoleList = []
      if (!this.form.roles || this.form.roles.length === 0) return allRoleList
      this.form.roles.forEach(role => {
        if(role.type != ROLE_TYPES.tourist) {
          let gradient = ''
          let color_list = []
          if (role.color_list && role.color_list.length == 2) { 
            color_list = role.color_list.map(c => this.colorConvert(c))
            gradient = `linear-gradient(90deg, ${color_list[0]} 0%, ${color_list[1]} 100%)`
          }
          let data = {
            label: role.name,
            icon: role.icon ? '' : 'icon-admin',
            image: role.icon,
            color: role.color,
            color_list,
            gradient,
            role
          }
          allRoleList.push(data)
        }
      })
      return allRoleList
    },
    // 可操作的权限组列表
    actionRoleList () {
      const ignoreList = [ROLE_TYPES.everyone, ROLE_TYPES.tourist]
      return this.allRoleList.filter(role => !ignoreList.includes(role.role.type) && this.source_position < role.role.position)
    },
    // 获取我是不是房主
    is_master () {
      return this.form.room.create_by && this.form.room.create_by == this.user_info.user_id
    },
    // 获取选中的人有没有权限组
    is_select_has_role () {
      return this.selectMemberList.filter(user => user.roles && user.roles.length).length > 0
    },
    enterTime(){
      return this.getEnterTimeFormat(member.join_time)
    },
    isValidInactiveCondition() {
      return this.inactiveConditions.some(item => item.time && item.type)
    },
    ...mapGetters([
      'show_theme_data',
      'user_info',
      'is_act_enable',
      'active_sidebar_tab',
      'online_state',
      'cur_my_roles',
      'cur_room_data',
    ]),
  },
  watch: {
    'filter_params.type_str': {
      handler(val) {
        if (!!val.trim()) {
          this.expensiveOperation()
        } else {
          this.memberSearchList = []
          this.offset = 0
          this.getMemberList(false, true)
        }
      },
      immediate: true
    },
    'rangeParams.level': {
      handler() {
        this.handleFilterChange(300)
      },
    },
    'rangeParams.join_times': {
      handler() {
        this.handleFilterChange(300)
      },
    },
    inactiveConditions: {
      handler(v) {
        this.handleFilterChange(300)
      },
      deep: true,
    },
    show: {
      handler(val) {
        if (val) {
          EventBus.$on('Refresh_Batch_Manage_List', this.refreshMemberList)
          this.getMemberList()
          this.scrollTimer = setTimeout(() => {
            this.addScrollListener()
          }, 1000)
        } else {
          EventBus.$off('Refresh_Batch_Manage_List', this.refreshMemberList)
          this.removeScrollListener()
          this.banInterval = null
          clearInterval(this.banInterval)
          clearTimeout(this.scrollTimer)
        }
      },
      immediate: true
    },
    selectMemberList (val) {
      if (val.length) {
        this.showActionPanel = true
      } else {
        this.showActionPanel = false
      }
      this.initActionList()
    },
    showMenuName(v){
      this.$nextTick(()=>{
        this.checkFilterRoleMenu(v)
      })
    },
  },
  methods: {
    handleFilterChange(delay) {
        clearTimeout(this.filterRequestTimer)
        this.filterRequestTimer = setTimeout(() => {
          this.getMemberList(false, true)
        }, delay)
    },
    // 初始化成员列表
    initMemberList (list = [], isUpdate = false) {
      const role_list = this.form.roles
      let ignoreList = [ROLE_TYPES.everyone, ROLE_TYPES.tourist]

      const ogList = this.isSearching ? this.memberSearchList : this.memberList

      if(!isUpdate){
        list = list.filter(item => ogList.findIndex(m => m.user_id === item.user_id) === -1)
      }
      list.forEach(item => {
        item.show_name = calcUserName(item)

        // 获取“我”对该成员是否有权限组的操作权限
        item.show_manage_role = (this.$permission.judgeUserPermission({
          roles: item.roles,
          user_id: item.user_id,
          type: 'ManageRoles'
        }) && (this.actionRoleList.length > 0)) || this.is_master
        
        // 获取“我”对该成员是否有禁言权限
        item.show_ban = this.$permission.judgeUserPermission({
          roles: item.roles,
          user_id: item.user_id,
          type: 'ProhibitedMemberTemporarily'
        })

        // 获取该用户的禁言状态
        if (item.ban?.until) {
          const end_time = Number(item.ban.until)
          const banned_time = end_time - Date.now() / 1000
          item.is_banned = banned_time > 0
        }

        // 获取“我”对该成员是否有移出房间权限
        item.show_kick_out = this.$permission.judgeUserPermission({
          roles: item.roles,
          user_id: item.user_id,
          type: 'KickOutRoom'
        })

        // 获取“我”对该成员是否有移出并拉黑权限
        item.show_black = item.show_kick_out && this.$permission.judgeUserPermission({
          roles: item.roles,
          user_id: item.user_id,
          type: 'CheckInRoomBlackList'
        })

        // 获取该成员的权限组
        item.roles = item.roles || []
        let user_roles = []
        item.roles.forEach(role_id => {
          const role = role_list.find(r => r.id == role_id)
          if (role) {
            user_roles.push(JSON.parse(JSON.stringify(role)))
          }
        })
        user_roles = user_roles.filter(role => !ignoreList.includes(role.type))
        user_roles = JSON.parse(JSON.stringify(user_roles))
        // 重新排序user_roles
        user_roles.sort((a, b) => {
          return a.position - b.position
        })
        user_roles.forEach(role => {
          // 计算颜色
          role.is_gradient = role.color_list && (role.color_list.length == 2)
          if (role.is_gradient) {
            role.color_list = role.color_list.map(color => this.colorConvert(color))
            role.color = role.color_list.join(',')
            role.gradient_color = `linear-gradient(90deg, ${role.color_list[0]} 0%, ${role.color_list[1]} 100%)`
          }
        })
        item.user_roles = user_roles
      })
      return list
    },
    // 初始化底部操作表盘
    initActionList () {
      this.action_list.forEach(action => {
        let cant_manage_list = []
        switch (action.type) {
          case 'add_role':
          case 'revoke_role':
            cant_manage_list = this.selectMemberList.filter(user => !user.show_manage_role)
            break;
          case 'ban_user':
            cant_manage_list = this.selectMemberList.filter(user => !user.show_ban)
            break;
          case 'kick_out_room':
            cant_manage_list = this.selectMemberList.filter(user => !user.show_kick_out)
            break;
          case 'kick_out_and_black':
            cant_manage_list = this.selectMemberList.filter(user => !user.show_black)
            break;
          default:
            break;
        }
        action.disabled = cant_manage_list.length > 0
        action.disabled_desc = ''
        if (cant_manage_list.length) {
          let desc = '没有权限对 '
          const list = cant_manage_list.slice(0, 2)
          desc += list.map(user => user.show_name).join('、')
          if (cant_manage_list.length > 2) {
            desc += `等 ${cant_manage_list.length} 位成员 `
          }
          desc += '进行此操作'
          action.disabled_desc = desc
        }
      })
    },
    
    // 选择、取消选择某个成员
    handleSelectMember(member) {
      const index = this.selectMemberList.findIndex(user => user.user_id == member.user_id)
      if (index > -1) {
        this.selectMemberList.splice(index, 1)
      } else {
        this.selectMemberList.push(member)
      }
    },
    // 显示成员操作菜单
    showMemberActionMenu (member, e) {
      const groups = [
        {
          items: [
            {
              hidden: !member.show_manage_role,
              component: 'child-menu',
              data: {
                label: '设置成员权限',
                groups: [
                  {
                    items: this.getManageRoleList(member)
                  }
                ]
              }
            },
            {
              hidden: !member.show_kick_out,
              component: 'menu-button',
              data: {
                label: '移出房间',
                type: 'warn',
              },
              onClick: () => {
                this.showConfirmKickOutMember([member])
              },
            },
            {
              hidden: !member.show_ban,
              component: 'menu-button',
              data: {
                label: member.is_banned ? '取消禁言' : '禁言用户',
                type: 'warn',
              },
              onClick: () => {
                this.handleBanUser(member)
              },
            },
            {
              hidden: !member.show_black,
              component: 'menu-button',
              data: {
                label: '移出并加入房间黑名单',
                type: 'warn',
              },
              onClick: () => {
                this.handleBlackUser([member])
              },
            },
          ],
          
        },
        {
          items: [
            {
              hidden: !this.is_master || member.user_id == this.user_info.user_id,
              component: 'menu-button',
              data: {
                label: '转让房间',
                type: 'warn',
              },
              onClick: () => {
                EventBus.$dynamic('transferRoomDialog', {
                  title: `将 ${this.form.room.room_name} 房间转让给 ${member.show_name}？`,
                  target: {
                    room_id: this.form.room.room_id,
                    room_name: this.form.room.room_name,
                    user_id: member.user_id
                  }
                })
              },
            },
          ]
        }
      ]
      this.$contextmenu({
        groups,
        event: e,
      })
    },

    // 点击底部操作面板
    handleActionPanel(action, event) {
      if (action.disabled) return
      // 底部操作面板一共5个操作，分别是：授予权限组、剥夺权限组、禁言、移出房间、移出并拉黑
      const type = action.type
      switch (type) {
        case 'add_role':
          this.showManageRoleMenu(event, null, true)
          break;
        case 'revoke_role':
          this.showRevokeRoleMenu(event, true)
          break;
        case 'ban_user':
          this.handleBanUser(this.selectMemberList, true)
          break;
        case 'kick_out_room':
          this.showConfirmKickOutMember(this.selectMemberList)
          break;
        case 'kick_out_and_black':
          this.handleBlackUser(this.selectMemberList)
          break;
        default:
          break;
      }
    },
    // 显示用户剥夺权限组的菜单
    showRevokeRoleMenu() {
      if (!this.is_select_has_role) return
      if (this.showBatchRoleMenu) {
        this.showBatchRoleMenu = false
        return
      }
      this.showBatchRoleList = this.getRevokeRoleList()
      this.isRevokeMenu = true
      this.showBatchRoleMenu = true

      document.querySelector('.full-dialog-page').addEventListener('click', this.hideBatchRoleMenu)
    },
    getRevokeRoleList () {
      const identityManage = []
      this.actionRoleList.forEach(role => {
        const user_role = role.role || {}
        if (!this.selectMemberList.some(user => user.roles && user.roles.includes(user_role.id))) return
        const data = JSON.parse(JSON.stringify(role))
        data.label = user_role.name
        
        identityManage.push({
          component: 'menu-button',
          data,
          onClick: () => {
            this.handleRevokeRoleUsers(this.selectMemberList, user_role)
          }
        })
      })
      return identityManage
    },

    // 显示用户添加权限组的菜单
    showManageRoleMenu(event, member, is_batch = false) {
      if (is_batch) {
        if (this.showBatchRoleMenu) {
          this.showBatchRoleMenu = false
          return
        }
        this.showBatchRoleList = this.getManageRoleList(member, true)
        this.isRevokeMenu = false
        this.showBatchRoleMenu = true

        document.querySelector('.full-dialog-page').addEventListener('click', this.hideBatchRoleMenu)
      } else {
        const groups = [{
          items: this.getManageRoleList(member, false)
        }]
        this.$contextmenu({
          groups,
          event,
          customClass: 'member-manage-role-menu',
        })
      }
    },
    hideBatchRoleMenu () {
      this.showBatchRoleMenu = false
      document.querySelector('.full-dialog-page').removeEventListener('click', this.hideBatchRoleMenu)
    },
    // 获取可添加权限组的菜单列表
    getManageRoleList (member, is_batch = false) {
      const identityManage = []
      this.actionRoleList.forEach(role => {
        const user_role = role.role || {}
        const data = JSON.parse(JSON.stringify(role))
        const item = {
          component: is_batch ? 'menu-button' : 'menu-selector',
        }
        if (is_batch) {
          data.label = user_role.name
          item.onClick = () => {
            this.handleAddRoleUsers(this.selectMemberList, user_role)
          }
        } else {
          data.selected = member.roles && member.roles.includes(user_role.id)
          data.confirm = () => {
            this.handleAddRoleUsers([member], user_role)
          }
          data.cancel = () => {
            this.handleRevokeRoleUsers([member], user_role)
          }
        }

        item.data = data
        identityManage.push(item)
      })
      if (member?.user_id == this.cur_room_data.create_by ||
        (is_batch && this.selectMemberList.length === 1 && this.selectMemberList[0].user_id == this.cur_room_data.create_by)
      ) {
        const punishRoleIndex = this.actionRoleList.findIndex(role => role.role.type === ROLE_TYPES.punish)
        if (punishRoleIndex !== -1) {
          identityManage.splice(punishRoleIndex, 1)
        }
      }
      return identityManage
    },
    handleRoleUsers (member = [], role) {
      if (!member || !member.length) return
      if (this.isRevokeMenu) {
        this.handleRevokeRoleUsers(member, role)
      } else {
        this.handleAddRoleUsers(member, role)
      }
    },
    // 添加权限组，单个或批量
    handleAddRoleUsers(member = [], role) {
      if (!member || !member.length) return
      role.id = role.id + ''
      if (role.type === ROLE_TYPES.punish) {
        const masterIndex = member.findIndex(user => user.user_id == this.cur_room_data.create_by)
        if (masterIndex > -1) {
          member.splice(masterIndex, 1)
          this.$toast.warning('房主不能被添加到惩罚权限组，已自动移除')
        }
      }
      if (member.length > 1) {
        // 给多个人添加某个权限组
        this.$query({
          config: {
            title: `已选中的 ${ member.length } 位成员，确定批量授予 ${role.name} 权限组？`,
            confirm: {
              text: '确定',
            },
            cancel: {
              text: '取消'
            }
          },
          confirmCB: async ()=> {
            batchAddRoleUsers({}, {
              to_user_ids: member.map(m => m.user_id),
              role_id: role.id,
              room_id: role.department_id,
            }).then(({ data }) => {
              if (data.status == 'ok') {
                this.updateRoles(member, role.id, 'add')
              }
            })
          }
        })
        
      } else {
        // 给单个人添加某个权限组
        addRoleUsers({}, {
          to_user_id: member[0].user_id,
          department_id: role.department_id,
          role_id: role.id,
          room_id: role.department_id,
        }).then(({ data }) => {
          if (data.status === 'ok') {
            this.updateRoles(member, role.id, 'add')
          }
        })
      }
    },
    // 移除权限组，单个或批量
    handleRevokeRoleUsers(member = [], role) {
      if (!member || !member.length) return
      role.id = role.id + ''
      if (member.length > 1) {
        // 给多个人移除某个权限组
        this.$query({
          config: {
            title: `已选中的 ${ member.length } 位成员，确定批量剥夺 ${role.name} 权限组？`,
            confirm: {
              text: '确定',
              type: 'alert'
            },
            cancel: {
              text: '取消'
            }
          },
          confirmCB: async ()=> {
            batchRevokeRoleFromUsers({}, {
              to_user_ids: member.map(m => m.user_id),
              role_id: role.id,
              room_id: role.department_id,
            }).then(()=>{
              this.updateRoles(member, role.id, 'remove')
            })
          }
        })
      } else {
        // 给单个人移除某个权限组
        revokeRoleFromUsers({}, {
          to_user_id: member[0].user_id,
          department_id: role.department_id,
          role_id: role.id,
          room_id: role.department_id,
        }).then(()=>{
          this.updateRoles(member, role.id, 'remove')
        })
      }
    },

    updateRoles (update_users, role_id, type = 'add') {
      update_users.forEach(user => {
        const roles = user.roles || []
        const index = roles.findIndex(r => r == role_id)
        if (type == 'add') {
          if (index === -1) {
            roles.push(role_id)
          }
        } else {
          if (index > -1) {
            roles.splice(index, 1)
          }
        }

        let show_user = null
        if (this.isSearching) {
          show_user = this.memberSearchList.find(mb => mb.user_id == user.user_id)
        } else {
          show_user = this.memberList.find(mb => mb.user_id == user.user_id)
        }
        if (show_user) {
          this.$set(show_user, 'roles', roles)
        }

        const select_user = this.selectMemberList.find(mb => mb.user_id == user.user_id)
        if (select_user) {
          this.$set(select_user, 'roles', roles)
        }
      })
      this.memberList = this.initMemberList(this.memberList, true)
      this.selectMemberList = this.initMemberList(this.selectMemberList, true)

      this.showBatchRoleMenu = false
      EventBus.$emit('Refresh_Member_List')
    },

    // 禁言、取消禁言
    handleBanUser (member, force_ban = false) {
      if (!member) return
      if (member.is_banned && !force_ban) {
        EventBus.$emit('CancelBanUser', member)
      } else {
        EventBus.$dynamic('BanUserDialog', true, member, 'batch_manage')
      }
    },

    // 踢出房间确认弹窗
    showConfirmKickOutMember (users) {
      let title = getFormatTitle(users)
      title += '移出房间？'
      this.$query({
        config: {
          title,
          desc: '用户将无法进入房间，直至再次被邀请',
          confirm: {
            text: '确定',
            type: 'alert'
          },
          cancel: {
            text: '取消'
          }
        },
        confirmCB: ()=> {
          this.handleKickOutUser(users)
        }
      })
    },
    // 踢出用户，单个或批量
    async handleKickOutUser(users = []) {
      if (!users || !users.length) return
      let data = null
      if (users.length > 1) {
        const res = await batchKickOutFromRoom({}, {
          room_id: this.form.room.room_id,
          to_user_ids: users.map(user => user.user_id),
        })
        data = res.data
      } else {
        const res = await kickOutFromRoom({ room_id: this.form.room.room_id }, {
          room_id: this.form.room.room_id,
          to_user_id: users[0].user_id
        })
        data = res.data
      }
      if (data.status == "ok") {
        this.$toast.success('操作成功')
        // 移除选中的成员
        this.removeMembers(users.map(user => user.user_id))
        this.selectMemberList = []
        if (this.memberList.length < 10) {
          this.getMemberList()
        }
      }
    },
    // 踢出并拉黑用户，单个或批量
    handleBlackUser (users = []) {
      if (!users || !users.length) return
      EventBus.$dynamic('AddRoomBlack', users, 'batch_manage')
    },

    // 表头的操作
    // 全选、取消全选成员
    handleChangeAll() {
      if (this.selectMemberList.length === this.showMemberList.length) {
        this.selectMemberList = []
      } else {
        this.selectMemberList = JSON.parse(JSON.stringify(this.showMemberList))
      }
    },
    // 隐藏筛选权限组的菜单
    hideFilterMenu () {
      this.showMenuName = ''
      this.customRangeName = ''
      this.removeListener()
    },
    // 筛选权限组变化
    handleFilterRoleChange (role) {
      const role_id = role.role.id
      const index = this.filter_params.role_ids.indexOf(role_id)
      if (index > -1) {
        this.filter_params.role_ids.splice(index, 1)
      } else {
        this.filter_params.role_ids.push(role_id)
      }
      this.handleFilterChange(500)
    },

    // 筛选状态变化
    handleFilterStatusChange () {
      this.filter_params.is_ban = !this.filter_params.is_ban
      this.handleFilterChange(500)
    },

    removeListener () {
      const page = document.querySelector('.full-dialog-page')
      if (page) {
        page.removeEventListener('click', this.clickHideFilterMenu)
      }
    },
    // 搜索的时候没有分页，只返回10个
    expensiveOperation: debounce(function () {
      this.selectMemberList = []
      this.getMemberList()
    }, 500),
    getMemberList (get_more = false, refresh = false) {
      if (this.lock) return
      this.lock = true
      this.no_more = false
      if (refresh) {
        this.offset = 0
      }
      if (get_more) {
        this.offset += this.limit
      }
      let params = {
        offset: this.offset,
        limit: this.limit,
        room_id: this.form.room.room_id,
      }
      this.filter_params.type_str = this.filter_params.type_str.trim()

      params = Object.assign(params, this.filter_params)
      if (get_more) {
        this.is_loading = true
      }

      // 由于有预设的参数以及自定义的参数，按优先级处理
      if(this.isUsingJoinTimeFilter || this.isUsingJoinTimeCustomFilter){
        params.join_times = this.isUsingJoinTimeCustomFilter ?
            this.enterTimeCustomRange.map(Number) : 
            this.rangeParams.join_times.map(item => {
              return new Date().getTime() - Number(item)
            })
      }

      if(this.isUsingLevelFilter || this.isUsingLevelCustomFilter){
        params.level = this.isUsingLevelCustomFilter ?
            this.levelCustomRange: 
            this.rangeParams.level.map(item => +item)
      }

      if(this.isValidInactiveCondition) {
        const union_filter_action = this.handleTransformInactiveCondition()
        if(union_filter_action) {
          params.union_filter_action = union_filter_action
        }
      }
      
      getManageMember({},params).then(res => {
        if(res.data.status == 'ok') {
          let { users } = res.data.result
          const user_list = this.initMemberList(users || [], refresh && !get_more)
          if (get_more && user_list.length === 0) {
            this.no_more = true
          }
          if (this.isSearching) {
            if (get_more) {
              this.memberSearchList.push(...user_list.filter(u => this.memberSearchList.findIndex(m => m.user_id == u.user_id) === -1))
            } else {
              this.memberSearchList = user_list
            }
          } else {
            if (get_more) {
              this.memberList.push(...user_list.filter(u => this.memberList.findIndex(m => m.user_id == u.user_id) === -1))
            } else {
              this.memberList = user_list
            }
          }
          // 将选中的列表中，没在当前列表中的成员去掉
          if (this.selectMemberList.length) {
            const list = this.isSearching ? this.memberSearchList : this.memberList
            this.selectMemberList = this.selectMemberList.filter(user => list.findIndex(u => u.user_id == user.user_id) > -1)
          }
        }
      }).finally(() => {
        this.lock = false
        this.is_loading = false
      })
    },
    refreshMemberList (args = {}) {
      const remove_ids = args.remove_ids || []
      if (remove_ids && remove_ids.length) {
        this.removeMembers(remove_ids)
      } else {
        this.getMemberList(false, true)
      }
      if (args.clear_select) {
        this.selectMemberList = []
      }
    },
    removeMembers (user_ids) {
      if (this.isSearching) {
        this.memberSearchList = this.memberSearchList.filter(user => user_ids.indexOf(user.user_id) === -1)
      } else {
        this.memberList = this.memberList.filter(user => user_ids.indexOf(user.user_id) === -1)
      }
    },
    addScrollListener () {
      const scrollWrapper = document.querySelector('.full-dialog-page .scroll-wrapper')
      scrollWrapper?.addEventListener('scroll', this.handleScroll)
    },
    removeScrollListener () {
      const scrollWrapper = document.querySelector('.scroll-item-wrapper .scroll-wrapper')
      scrollWrapper?.removeEventListener('scroll', this.handleScroll)
    },
    checkFilterRoleMenu () {
      if(!this.showMenuName) return
      const type = `filter-${this.showMenuName}-menu`
      const menuDom = this.$refs[type]
      if (menuDom) {
        const { top, bottom } = menuDom.getBoundingClientRect()
        const screenHeight = document.documentElement.clientHeight
        if (screenHeight - bottom < -100) {
          this.MenuPosition = {
            top: 'auto',
            bottom: 'calc(100% + 10px)'
          }
        } else if (top < -100) {
          this.MenuPosition = {
            top: 'calc(100% + 10px)',
            bottom: 'auto'
          }
        }
      }
    },
    handleScroll (e) {
      this.checkFilterRoleMenu()
      if(this.showMenuName === 'inactive-filter') {
        this.handleShowMenu('inactive-filter')
      }
      // 筛选菜单显示的时候，控制菜单显示位置
      if (this.lock || this.no_more || this.isSearching) return
      const scrollWrapper = e.target
      const scrollHeight = scrollWrapper.scrollHeight
      const scrollTop = scrollWrapper.scrollTop
      const clientHeight = scrollWrapper.clientHeight
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        this.getMemberList(true)
      }
    },
    handleMouseOverBan (member) {
      if (member.is_banned) {
        const end_time = Number(member?.ban?.until)
        if (!end_time) return
        let banned_time = Math.round(end_time - Date.now() / 1000)
        if (banned_time > 0) {
          if (this.banInterval) {
            clearInterval(this.banInterval)
          }
          this.hoverBanDesc = '已被禁言，还剩 ' + formatLeftTime(banned_time)
          this.banInterval = setInterval(() => {
            banned_time --
            this.hoverBanDesc = '已被禁言，还剩 ' + formatLeftTime(banned_time)
            if (banned_time <= 0) {
              clearInterval(this.banInterval)
              this.hoverBanDesc = ''
              this.$set(member, 'is_banned', false)
            }
          }, 1000)
        } else {
          this.$set(member, 'is_banned', false)
        }
      }
    },
    handleMouseLeaveBan () {
      this.hoverBanDesc = ''
      clearInterval(this.banInterval)
    },
    showUserCard (event, member) {
      // @click.native.stop="userCardMenuHandler($event, 'fixed_left', JSON.parse(JSON.stringify(member)))"

      EventBus.$emit('User_Menu:card', event, 'fixed_left', JSON.parse(JSON.stringify(member)),{origin:false});
    },
    closeActionPanel () {
      this.selectMemberList = []
    },
    colorConvert(num) {
      return num ? decimalToHexColor(num) : 'var(--opacity-6)'
    },
    handleShowMenu(name){
      if(this.showMenuName === name){
        this.hideFilterMenu()
        return 
      }
      this.showMenuName = name
      if(['enter-time', 'level'].includes(name)){
        switch(name){
          case 'enter-time': 
            this.isUsingJoinTimeCustomFilter && (this.customRangeName = name)
            break
          case 'level':
            this.isUsingLevelCustomFilter && (this.customRangeName = name)
            break
        }
      }
      document.querySelector('.full-dialog-page').addEventListener('click', this.clickHideFilterMenu)
    },
    handleClickInviteUser(){},
    getInviteTooltip(member){
      const { invitor } = member
      return `邀请人：${invitor?.user?.nickname}，邀请码：${invitor?.invite_code}`
    },
    showUserInviteCode(member){
      EventBus.$dynamic('RoomInviteCodeManage', member?.invitor?.user)
    },
    handleUpdateLevelCustomRange(value){
      this.levelCustomRange = value
      if(value.length === 2 && value[0] <= value[1] ){
        this.handleFilterChange(300)
      }
    },
    handleUpdateEnterTimeCustomRange(value){
      const { timestamp_start, timestamp_end } = value
      const start = timestamp_start.getTime()
      const end = timestamp_end.getTime()
      if(timestamp_start && timestamp_end && start < end){
        this.enterTimeCustomRange = [start, end]
        this.handleFilterChange(300)
      }
    },
    getEnterTimeFormat(timestamp){
      if (!["string", "number"].includes(typeof timestamp)) return;
      const timestampLength = timestamp.toString().length;
      timestamp = parseInt(timestamp);
      if (timestampLength === 10) {
        timestamp = timestamp * 1000;
      }
      let time = new Date(timestamp);
      let ye = time.getFullYear();
      let mo = time.getMonth() + 1;
      let da = time.getDate();
      let hour = time.getHours();
      let minute = time.getMinutes();
      hour = hour < 10 ? "0" + hour : hour;
      minute = minute < 10 ? "0" + minute : minute;
      let res = `${ye}.${mo}.${da} ` + `${hour + ":" + minute}`;
      return res;
    },
    clickHideFilterMenu(e){
      const preventDoms = [
        ...document.querySelectorAll('.cpt-time-selector'),
        ...document.querySelectorAll('.cpt-inactive-member-filter'),
      ]
      if(e.target.classList.contains('condition-item-remove') || e.target.parentNode.classList.contains('condition-item-remove')) {
        return
      }
      for(let d of preventDoms){
        if(d && d.contains(e.target)){
          return 
        }
      }
      this.hideFilterMenu()
    },
    dateFormatter(v1, v2) {
      if (v1 == '0' || v2 == '0') return '';
      // 定义一个函数来格式化日期
      const format = (timestamp) => {
        const date = new Date(timestamp);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份从 0 开始，所以需要加 1
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}.${month}.${day}`;
      };
      return `${format(v1)} - ${format(v2)}`;
    },
    handleHoverMember(event, target) {
      const userId = target ? target.getAttribute('data-delegate-member-item') : ''
            
      this.hoverMemberId = userId

      const member = this.showMemberList.find(m => m.user_id == userId)
      if (!member) return

      this.hoverMember = member
      if (member.show_manage_role) {

        const memberRect = target.getBoundingClientRect()
        const containerRect = this.$el.getBoundingClientRect()
        
        const roleElement = target.querySelector('.member-role')
        const roleElementRect = roleElement.getBoundingClientRect()
        
        let roleContentWidth = 0
        const roleItem = roleElement.querySelector('.role-item')
        if (roleItem) {
          roleContentWidth += roleItem.offsetWidth
        }
        
        const moreRole = roleElement.querySelector('.more-role')
        if (moreRole) {
          roleContentWidth += moreRole.offsetWidth + 6 
        }
        
        this.addRoleBtnStyle = {
          top: `${memberRect.top - containerRect.top - 128}px`,
          left: roleContentWidth > 0 
            ? `${roleElementRect.left - containerRect.left + roleContentWidth + 18}px`
            : `${roleElementRect.left - containerRect.left + 12}px`
        }
        
      }
    },
    handleMouseLeave(event) {
      const relatedTarget = event.relatedTarget
      if (relatedTarget) {
        if (relatedTarget.closest('.add-role-btn')) {
          return
        }
        if (relatedTarget.closest('.member-item')) {
          return
        }
      }
      this.hoverMember = null
      this.hoverMemberId = ''
    },
    handleAddRoleBtnLeave(event) {
      const relatedTarget = event.relatedTarget;
      if (relatedTarget) {
        if (relatedTarget.closest('.member-item')) {
          return;
        }
      }
      
      this.hoverMember = null;
      this.hoverMemberId = ''
    },
    handleAddCondition(value){
      this.inactiveConditions.push({time: undefined, type: undefined, id: this.randomToken()})
    },
    handleRemoveCondition({index}){
      this.inactiveConditions.splice(index, 1)
    },
    handleChangeCondition({index, key, value}){
      if(this.inactiveConditions[index]) {
        this.$set(this.inactiveConditions[index], key, value)
      }
    },
    handleTransformInactiveCondition() {
      const validConditions = this.inactiveConditions.filter(({time, type}) => time && type)
      if (validConditions.length) {
        return validConditions.map(({time, type}) => {
          const now = Math.floor(new Date().setHours(0, 0, 0, 0) / 1000);
          return {
            action: type.value,
            before_ts: now - time.range[0],
            after_ts: 0,
          }
        })
      } else {
        return null
      }
    },
    randomToken(){
      return new Array(16).fill(0).map(() => Math.floor(Math.random() * 16).toString(16)).join('')
    },
    getInactiveText(member) {
      // 展示优先级 未语音 > 未发言 > 未浏览
      const map = {
        visit: '未访问',
        voice: '未语音',
        message: '未发言',
      }
      const { action } = member
      const inactiveConditions = this.inactiveConditions
      const showTypes = []
      const hasVisit = inactiveConditions.some(({type}) => type?.value === 'visit')
      const hasVoice = inactiveConditions.some(({type}) => type?.value === 'voice')
      const hasMessage = inactiveConditions.some(({type}) => type?.value === 'message')
      hasVoice && showTypes.push('voice')
      hasMessage && showTypes.push('message')
      hasVisit && showTypes.push('visit')
      if(action) {
        for(let i = 0; i < showTypes.length; i++) {
          const [state, text] = this.getInactiveTimeText(action[`${showTypes[i]}_at`])
          if(state) {
            return `${text}${map[showTypes[i]]}`
          }
        }
      } else {
        return ''
      }
    },
    getInactiveTimeText (ts) {
      const TIME_STATE_MAP = {
        NORMAL: 0, // 正常活跃
        ONE_MONTH: 1, // 一个月不活跃
        THREE_MONTH: 2, // 三个月不活跃
        SIX_MONTH: 3, // 半年
        ONE_YEAR: 4, // 一年
        NEVER: 5, // 从未活跃
      }
      if(!ts) return [TIME_STATE_MAP.NEVER, '从']
      const sTimeStamp = Math.floor(Date.now() / 1000) // 秒级时间戳
      const ONE_MONTH_TIME_STAMP = 30 * 24 * 60 * 60 // 一个月的秒数
      const diff = sTimeStamp - ts 
      if(diff < ONE_MONTH_TIME_STAMP) {
        return [TIME_STATE_MAP.NORMAL, '']
      } else if(diff < ONE_MONTH_TIME_STAMP * 3) {
        return [TIME_STATE_MAP.ONE_MONTH, '一个月']
      } else if(diff < ONE_MONTH_TIME_STAMP * 6) {
        return [TIME_STATE_MAP.THREE_MONTH, '三个月']
      } else if(diff < ONE_MONTH_TIME_STAMP * 12) {
        return [TIME_STATE_MAP.SIX_MONTH, '六个月']
      } else {
        return [TIME_STATE_MAP.ONE_YEAR, '一年']
      }
    },
  }
}
</script>

<style lang="scss">
.member-manage-role-menu {
  overflow-y: scroll;
  max-height: 80%;
  padding-right: 0 !important;
}
.role-tip-content {
  display: flex;
  flex-wrap: wrap;
  width: 224px;
  margin-top: 2px;
  margin-bottom: -6px;
  .role-item {
    margin-bottom: 6px;
  }
}
.role-list-wrapper {
  .role-item {
    height: 30px;
    padding: 0 6px;
    border-radius: 4px;
    background: $d-op-1;
    display: flex;
    align-items: center;
    &:not(:last-child) {
      margin-right: 6px;
    }
    .role-name {
      padding: 0;
      max-width: 47px;
      font-size: 12px;
      line-height: 16px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      &.gradient-text {
        color: transparent;
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
  }
  .more-role {
    margin-right: 6px;
    height: 30px;
    border-radius: 4px;
    background: $d-op-1;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &.more-role {
      padding: 0 7px;
      color: $d-op-6;
      font-family: Roboto;
      font-size: 12px;
      font-weight: 500;
      line-height: 16px;
    }
  }
}
.cpt-member-manage-scroll-item-wrapper {
  .top-block {
    display: flex;
    align-items: center;
    gap: 6px;
    .inactive-filter-btn {
      &.active {
        background: $d-fl-sl;
        color: $d-bd-tx;
        &>.iconfont {
          color: $d-bd-tx;
        }
      }
      &>.iconfont {
        font-size: 8px;
        color: $d-op-3;
      }
    }
    .heybox-context-menu {
      width: 334px;
      max-height: 450px;
      overflow-y: scroll;
      position: absolute;
      top: 50px;
      right: 10px;
      padding: 8px;
      padding-right: 0;
      z-index: 2;
    }
  }
  &.scroll-item-wrapper {
    .module {
      padding-bottom: 70px;
      position: relative;
      .member-table {
        .select {
          width: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
          .iconfont {
            font-size: 18px;
            color: $d-bd-tx;
          }
          .none-select {
            width: 16px;
            height: 16px;
            border: 2px solid $d-op-2;
            border-radius: 2px;
          }
        }
        .member-info {
          width: 175px;
          display: flex;
          align-items: center;
          padding-left: -2px;
        }
        .member-hb-level {
          width: 42px;
          display: flex;
          align-items: center;
          color: $d-tx-3;
          text-align: center;

          font-size: 12px;
          line-height: 16px;
          letter-spacing: 0.12px;
        }
        .member-invite-info{
          display: flex;
          width: 56px;
          justify-content: center;
          align-items: center;

          color: $d-tx-3;
          text-align: center;
          font-size: 12px;
          line-height: 16px;
          letter-spacing: 0.12px;
          .member-invitor-avatar{
            width: 24px;
            height: 24px
          }
        }
        .member-role {
          display: flex;
          align-items: center;
          width: 161px;
          padding-left: 10px;
        }
        .member-status {
          flex: 1;
          width: 0;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .member-table-head {
          height: 40px;
          display: flex;
          align-items: center;
          position: relative;
          &::after {
            content: '';
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 1px;
            background-color: $d-ln-1;
          }
          .select {
            cursor: pointer;
          }
          
          .member-info {
            color: $d-tx-3;
            font-size: 12px;
            line-height: 16px;
            cursor: pointer;
          }
          .filter-head-item {
            display: flex;
            align-items: center;
            .flex {
              display: flex;
              align-items: center;
              cursor: pointer;
              position: relative;
              gap: 1px;
            }
            &.member-status{
              span{
                min-width: 24px;
              }
            }
            span {
              color: $d-tx-3;
              font-size: 12px;
              line-height: 16px;
            }
            .filter-wrapper {
              display: flex;
              align-items: center;
              &.active {
                span, .iconfont {
                  color: $d-bd-tx;
                }
              }
              span {
                margin-right: 3px;
              }
              .iconfont {
                font-size: 16px;
                color: $d-tx-4;
                transition: transform .2s;
                &.icon-filter{
                  cursor: pointer;
                }
                &.rotate {
                  transform: rotate(180deg);
                }
                &.active{
                  color: $d-bd-tx;
                }
              }
            }
            .heybox-context-menu {
              width: 224px;
              max-height: 450px;
              overflow-y: scroll;
              
              position: absolute;
              top: calc(100% + 12px);
              left: 50%;
              transform: translateX(-50%);
              padding: 8px;
              padding-right: 0;
              z-index: 2;
              &.heybox-context-menu-range{
                width: 334px;
                left: 73%;
                padding: 8px;
                box-shadow: 0px 3px 15px 0px rgba(0, 0, 0, 0.35);
                &.time-panel {
                  top: calc(100% + 202px);
                }
                &.level-panel {
                  top: calc(100% + 170px);
                }
              }
              &.status-menu {
                bottom: auto;
                top: calc(100% + 12px);
                left: 20%;
                width: 188px;
              }
              &.enter-time-menu {
                top: 100%;
                left: 21%;
              }
              &.level-menu {
                top: 100%;
                left: 45%;
                &.has-custom {
                  left: 21%;
                }
              }
              .menu-item {
                width: 100%;
                height: 32px;
                padding: 0 8px;
                display: flex;
                align-items: center;
                color: $d-ss-tx;
                border-radius: 5px;
                cursor: pointer;
                &.gradient {
                  i, span {
                    color: transparent;
                    background-clip: text;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                  }
                }
                i.icon-history {
                  color: $d-er-tx;
                  font-size: 16px;
                }
                span {
                  font-size: 14px;
                  margin: 0 6px;
                  flex: 1;
                  width: 0;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  overflow: hidden;
                  color: $d-tx-2;
                }
                &:hover {
                  background: $d-bd-fl;
                  color: $ct-wh-0;    
                  // color: $d-tx-1;    
                  .icon-dot {
                    color: $ct-wh-0;
                  }
                  .radio {
                    border: 2px solid $ct-wh-0 !important;
                    &::after {
                      background: $ct-wh-0 !important;
                    }
                  }
                  .select-icon {
                    .unselected {
                      border: 2px solid $ct-wh-0 !important;
                    }
                    .selected {
                      color: $ct-wh-0 !important;
                    }
                  }
                }
                .radio {
                  width: 16px;
                  height: 16px;
                  margin-left: auto;
                  border: 2px solid $d-op-3;
                  border-radius: 50%;
                  flex-shrink: 0;
                  &.active {
                    border: 2px solid $d-ss-tx;
                    position: relative;
                    &::after {
                      content: "";
                      position: absolute;
                      width: 8px;
                      height: 8px;
                      left: 50%;
                      top: 50%;
                      transform: translate(-50%, -50%);
                      background: $d-ss-tx;
                      border-radius: 50%;
                    }
                  }
                }
                .select-icon {
                  height: 16px;
                  width: 16px;
                  .unselected {
                    height: 16px;
                    width: 16px;
                    border: 2px solid $d-op-3;
                    border-radius: 8px;
                  }
                  .selected {
                    color: $d-bd-tx;
                    background-clip: unset;
                    -webkit-text-fill-color: unset;
                  }
                }
              }
            }
          }
          .member-status {
            padding-right: 28px;
          }
        }
        .member-table-body {
          // overflow-y: auto;
          position: relative;
          .member-list {
            .member-item {
              height: 50px;
              display: flex;
              align-items: center;
              cursor: pointer;
              border-radius: 3px;
              transition: background .2s;
              &:hover {
                background: $d-op-2;
              }
              .member-info {
                gap: 10px;
                .member-info-right{
                  display: flex;
                  flex-direction: column;
                  .member-name {
                    max-width: 130px;
                    padding-right: 10px;
                    color: $d-tx-2;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                    font-size: 13px;
                    line-height: 18px;
                    display: flex;
                    align-items: center;
                    .show-name{
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      overflow: hidden;
                    }
                    .master-tag {
                      flex-shrink: 0;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      width: 27px;
                      height: 14px;
                      margin-left: 5px;
                      border-radius: 3px;
                      background: $d-wn-fl;
                      color: $ct-wh-0;
                      font-weight: 400;
                      letter-spacing: 0.1px;
                      font-size: 12px;
                      transform: scale(.8334);
                    }
                  }
                  .member-enter-time{
                    overflow: hidden;
                    color: $d-tx-3;  
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-size: 12px;
                    font-weight: 400;
                  }
                  .member-inactive-time {
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    align-self: stretch;
                    overflow: hidden;
                    color: $d-ol-tx;
                    text-overflow: ellipsis;
                    font-size: 12px;
                    line-height: 14px;
                  }
                }
              }
              .member-role {
                display: flex;
                align-items: center;
                padding-left: 12px;
              }
              .member-status {
                .iconfont {
                  color: $d-er-tx;
                }
                .flex{
                  span{
                    min-width: 24px;
                  }
                }
              }
              .member-hb-level{
                width: 42px;
                display: flex;
                justify-content: center;
                align-items: center;
                .heybox-level { 
                  position: relative;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  .num{
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%) scale(.5);
                    font-size: 20px;
                    line-height: 16px;
                    letter-spacing: 0.12px;

                    color: $ct-wh-0;
                  }
                }
              }
              .member-invite-info{
                display: flex;
                width: 56px;
                justify-content: center;
                align-items: center;
                gap: 4px;
                align-self: stretch;
              }
              .action-btn {
                margin-right: 4px;
                width: 24px;
                height: 24px;
                border-radius: 3px;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                &:hover {
                  background: $d-op-1;
                }
                .iconfont {
                  color: $d-tx-3;
                }
              }
            }
          }
        }
      }
      .action-panel {
        position: sticky;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 50px;
        padding: 0 16px;
        padding-right: 11px;
        display: flex;
        align-items: center;
        border-radius: 8px;
        border: 1px solid $d-op-1;
        background: $d-fl-pp;
        box-shadow: 0px 3px 15px 0px rgba(0, 0, 0, 0.35);
        z-index: 2;
        .select-desc {
          width: 84px;
          color: $d-tx-3;
          font-size: 12px;
          line-height: 16px;
          white-space: nowrap;
        }
        .action-item {
          margin-left: 5px;
          padding: 0 10px;
          height: 30px;
          display: flex;
          align-items: center;
          border-radius: 4px;
          cursor: pointer;
          color: $d-tx-2;
          font-size: 12px;
          line-height: 16px;
          white-space: nowrap;
          &.red {
            color: $d-er-tx;
          }
          &.disabled {
            opacity: .4;
            cursor: not-allowed;
            &:hover {
              background: transparent;
            }
          }
          &:hover {
            background: $d-op-2;
          }
          i {
            color: $d-tx-4;
            width: 12px;
            height: 12px;
            font-size: 12px;
            display: inline-flex;
            transition: transform .2s;
            transform: scale(.5);
            &.rotate {
              transform: scale(.5) rotate(180deg);
            }
          }
          &.red {
            color: $d-er-tx;
            i {
              color: $d-er-tx;
            
            }
          }
        }
        .close-btn {
          margin-left: 10px;
          width: 22px;
          height: 22px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 3px;
          cursor: pointer;
          flex-shrink: 0;
          &:hover {
            background: $d-op-2;
          }
          i {
            font-size: 12px;
            color: $d-tx-3;
          }
        }
      }
    }
    .slide-enter-active, .slide-leave-active {
      transition: all 0.16s ease-out;
    }
  
    .slide-enter, .slide-leave-to {
      transform: translateY(100%);
      opacity: 0;
    }
  
    .slide-enter-to, .slide-leave {
      transform: translateY(0);
      opacity: 1;
    }
  }
  
  .heybox-context-menu {
    padding: 8px;
    background-color: $d-fl-pp;
    border: 1px solid $d-op-1;
    box-shadow: 0px 2px 13px rgba(0, 0, 0, 0.07);
    border-radius: 5px;
    &.role-menu {
      position: absolute;
      left: 60px;
      bottom: 100%;
      overflow-y: auto;
      max-height: 70vh;
      &.revoke-menu {
        left: 152px;
      }
    }
  }
}
.transfer-confirm-dialog {
  .dialog-title-group {
    .desc {
      color: $d-er-tx !important;
    }
  }
  .del-confirm {
    .form-item {
      .name {
        margin-bottom: 6px;
        color: $d-tx-3;
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
      }
    }
  }
}

</style>